
import { PropType, defineComponent } from 'vue'

export default defineComponent({
  name: 'IconOpenInNewTab',

  props: {
    width: {
      type: [String, Number] as PropType<string | number>,
      default: 12
    },
    height: {
      type: [String, Number] as PropType<string | number>,
      default: 12
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
})
